import { ChangeEvent, memo } from 'react'
import clsx from 'clsx'

import styles from './Switch.module.scss'

export type SwitchVariant = 'primary' | 'secondary'

export interface SwitchProps {
  id: string
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  variant?: SwitchVariant
  className?: string
  ariaLabel?: string
}

const Switch = ({
  id,
  checked,
  onChange,
  disabled = false,
  variant = 'primary',
  className,
  ariaLabel
}: SwitchProps) => {
  return (
    <label
      className={clsx(
        styles.switch,
        { [styles.disabled]: disabled },
        className
      )}
      htmlFor={id}
    >
      <input
        id={id}
        type='checkbox'
        role='switch'
        checked={checked}
        aria-label={ariaLabel}
        onChange={onChange}
        disabled={disabled}
        className={styles.input}
      />
      <span
        className={clsx(styles.track, {
          [styles.trackPrimaryChecked]: checked && variant === 'primary',
          [styles.trackSecondaryChecked]: checked && variant === 'secondary',
          [styles.trackDisabled]: disabled
        })}
      >
        <span
          className={clsx(styles.thumb, {
            [styles.thumbChecked]: checked,
            [styles.thumbDisabled]: disabled
          })}
        />
      </span>
    </label>
  )
}

export default memo(Switch)
